import { createContext } from 'react';

const NotificationsContext = createContext();

NotificationsContext.displayName = 'NotificationsContext';

export default NotificationsContext;
